import ActionTypes from '../ActionTypes';

// eslint-disable-next-line import/prefer-default-export
export function createLogAction(message) {
  return {
    type: ActionTypes.Log,
    payload: message,
  };
}
